"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Recharge = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsAccount_1 = require("../../model/hsAccount");
var service_1 = require("../../../library/base/service");
var Recharge = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Recharge, _super);
    function Recharge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '账户余额充值接口';
        _this.code = '105001';
        _this.desc = '账户余额充值接口';
        _this.requestParams = new hsAccount_1.RechargeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Recharge;
}(service_1.BaseService));
exports.Recharge = Recharge;
//# sourceMappingURL=recharge.js.map